import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { Subject, takeUntil } from 'rxjs';
import { ResourceStatus } from 'src/app/common';
import { ResourceService, bucketItem } from 'src/app/services/resource.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-manage-resource',
  templateUrl: './manage-resource.component.html',
  styleUrls: ['./manage-resource.component.scss']
})
export class ManageResourceComponent {
  ResourceStatus = ResourceStatus;
  total: number;
  limit = 100;
  from = 0;
  resources: any[];
  selected: any;
  criteria = {
    Keyword: undefined,
    IsReady: undefined,
    HasDescription: undefined,
    Status: ResourceStatus.Pending,
    Type: undefined,
    Source: undefined,
    Tags: [],
    Sort: 'UpdateTime'
  }
  @ViewChild('resourceModal') resourceModal: NgxSmartModalComponent;
  sources: bucketItem[];
  tags: bucketItem[];
  types: bucketItem[];
  updatdeStatus = null;
  updatdeType = null;
  aggs: any;

  constructor(private route: ActivatedRoute, private resourceService: ResourceService, private sharedService: SharedService) {
    this.sharedService.navigationEnd$.pipe(takeUntil(this.unsubscribe$)).subscribe(async () => await this.load());
  }

  async ngOnInit() {
    this.sources = await this.resourceService.getSources(true);
    this.tags = await this.resourceService.getTags(true);
    this.types = await this.resourceService.getTypes(true);
    ResourceService.resourceTypes.filter(t => !this.types.find(_ => _.Key == t)).forEach(t => this.types.push({ Key: t, DocCount: 0 }));
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async load(from?: number) {
    if (from == undefined)
      this.from = this.route.snapshot.queryParams.from;

    delete this.resources;
    if (from != undefined) this.from = from;
    setTimeout(async () => {
      var result = await this.resourceService.search({
        Keyword: this.criteria.Keyword,
        IsReady: this.criteria.IsReady,
        HasDescription: this.criteria.HasDescription,
        Types: this.criteria.Type === undefined || this.criteria.Type?.startsWith('-') ? undefined : [this.criteria.Type],
        HasType: this.criteria.Type == '-not-set' ? false : (this.criteria.Type == '-set' ? true : undefined),
        Statuses: this.criteria.Status != undefined ? [this.criteria.Status] : undefined,
        SourceNames: this.criteria.Source != undefined ? [this.criteria.Source] : undefined,
        Tags: this.criteria.Tags,
        Sort: this.criteria.Sort,
        IncludeAggs: true
      }, this.from, this.limit, true);
      this.resources = result.resources;
      this.total = result.total;
      this.aggs = result.aggs;
    });
    this.resourceModal?.close();

  }

  openModal(resource?: any) {
    this.selected = Object.assign({}, resource || {});
    this.resourceModal.open();
  }

  async onSave(resource: any) {
    this.resources = this.resources.map(r => r.Id == resource.Id ? resource : r);
    this.resourceModal.close();
  }

  toggleSelectAll(checked: boolean) {
    this.resources.forEach(_ => _._selected = checked);
  }

  async bulkUpdate(partial: any) {
    var ids = this.resources.filter(_ => _._selected).map(_ => _.Id);
    if(!ids?.length ) {
      alert('لطفا حداقل یک مورد را انتخاب کنید');
      return;
    }
    var result = await this.resourceService.bulkUpdate(ids, partial);
    this.resources = this.resources.map(r => ({ ...(result.find(_ => r.Id == _.Id) || r), _selected: r._selected }));

  }

  async reindex() {
    var urls = this.resources.filter(_ => _._selected).map(_ => _.Source?.Url).filter(_ => !!_);
    await this.resourceService.reindex(urls);
  }
}
